/* URSA high-priority conversion fixes (added 3 Oct 2026). See ursa-high-fixes.css for the list. */
(function () {
  'use strict';

  /* 1. Size guide link next to the Size option (not Pouch Size). The guide is on the FAQs page.
     6 Oct 2026: no longer called. Replaced by the inline size guide in ursa-size-guide.js (loaded from sections/ursa-product-tools.liquid). */
  function sizeLink() {
    document.querySelectorAll('variant-picker legend').forEach(function (lg) {
      if (lg.querySelector('.uhf-size-link')) return;
      if (!/^\s*size\b/i.test(lg.textContent || '')) return;
      var a = document.createElement('a');
      a.className = 'uhf-size-link';
      a.href = '/pages/faqs#sizes';
      a.textContent = 'Size guide';
      a.target = '_blank';
      a.rel = 'noopener';
      lg.appendChild(a);
    });
  }

  /* 2. Photo counter on phones */
  function counter() {
    var mg = document.querySelector('media-gallery');
    if (!mg || mg.querySelector('.uhf-count')) return;
    var host = mg.querySelector('slideshow-component');
    var count = mg.querySelectorAll('.slideshow-controls__thumbnail').length;
    if (!host || count < 2) return;
    var c = document.createElement('div');
    c.className = 'uhf-count';
    c.setAttribute('aria-hidden', 'true');
    host.appendChild(c);
    mg.classList.add('uhf-has-count');
    function update() {
      var b = Array.prototype.slice.call(mg.querySelectorAll('.slideshow-controls__thumbnail'));
      var i = b.findIndex(function (x) { return x.getAttribute('aria-selected') === 'true'; });
      c.textContent = (i < 0 ? 1 : i + 1) + ' / ' + b.length;
    }
    update();
    if (window.MutationObserver) {
      new MutationObserver(update).observe(mg, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
    }
  }

  /* 3. Reassurance row under the buy buttons */
  function assure() {
    var bb = document.querySelector('.product-details .buy-buttons-block');
    if (!bb || document.querySelector('.uhf-assure')) return;
    var ul = document.createElement('ul');
    ul.className = 'uhf-assure';
    ['30-day returns', 'Dispatched in 1 to 2 working days', 'Secure checkout'].forEach(function (t) {
      var li = document.createElement('li');
      li.textContent = t;
      ul.appendChild(li);
    });
    bb.insertAdjacentElement('afterend', ul);
  }

  /* 5. Collection intro above the grid, FAQ below it */
  function collectionBits() {
    /* 17 Oct 2026 (G14): category pages with the collection hub no longer have results-list, so anchor to the hub (same section) */
    var rl = document.querySelector('results-list') || document.querySelector('.uch');
    var sec = rl && rl.closest('.shopify-section');
    if (!sec) return;
    var intro = document.getElementById('uhf-intro');
    var faq = document.getElementById('uhf-faq');
    if (intro && intro.nextElementSibling !== sec && intro.parentNode !== sec.parentNode) return;
    if (intro && intro.nextElementSibling !== sec) sec.insertAdjacentElement('beforebegin', intro);
    if (faq && sec.nextElementSibling !== faq) sec.insertAdjacentElement('afterend', faq);
  }

  /* FAQs page: open and scroll to the strap sizes answer when linked with #sizes */
  function faqHash() {
    if (location.hash !== '#sizes') return;
    var nodes = document.querySelectorAll('main summary, main button, main [role="button"], main h3, main h4');
    var t = null;
    for (var i = 0; i < nodes.length; i++) { if (/what sizes are your straps/i.test(nodes[i].textContent)) { t = nodes[i]; break; } }
    if (!t) return;
    var d = t.closest('details');
    if (d && !d.open) d.open = true;
    else if (t.getAttribute('aria-expanded') === 'false') t.click();
    setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
  }

  /* 6 Oct 2026 (Simon feedback): About page, email under each team member's name. Cat and Laura have no email. */
  function teamEmails() {
    var people = document.querySelectorAll('#ursa-about .uab-person');
    if (!people.length) return;
    var MAIL = { 'simon bysshe & laura smith': 'simon@ursastraps.com', 'sam clarke': 'sam@ursastraps.com', 'jodie bartlett': 'jodie@ursastraps.com' };
    people.forEach(function (li) {
      if (li.querySelector('.uab-mail')) return;
      var n = li.querySelector('.uab-name');
      var e = n && MAIL[n.textContent.trim().toLowerCase()];
      if (!e) return;
      var a = document.createElement('a');
      a.className = 'uab-mail';
      a.href = 'mailto:' + e;
      a.textContent = e;
      li.appendChild(a);
    });
  }

  function run() { counter(); assure(); }
  function init() {
    run();
    collectionBits();
    faqHash();
    teamEmails();
    var tm;
    if (window.MutationObserver) {
      var root = document.getElementById('MainContent') || document.body;
      /* 17 Oct 2026: run() straight away as well (not only 150ms later). The theme re-renders the product section on every size/colour tap and
         removes the photo counter and the reassurance row; putting them back in the same tick means the browser never paints the page without
         them (before: the gallery controls bar reappeared and the page below jumped). run() returns early when both already exist. */
      new MutationObserver(function () { run(); clearTimeout(tm); tm = setTimeout(run, 150); }).observe(root, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 6 Oct 2026: the waist size finder loader that was here (ursa-size-finder.js/.css, unversioned so the CDN served stale copies) is removed.
   Size guide + Find my size now load from sections/ursa-product-tools.liquid as ursa-size-guide.js/.css. Backup: assets/ursa-high-fixes.js.before-size-guide-2026-10-06.txt (git tag pre-cleanup-2026-10-19) */

/* URSA custom (6 Oct 2026, Simon feedback): URSA Tape page. Pack Size and Colour are linked, because 12 Small Strips Multi-Pack only exists as Colour = Multipack. Without this, clicking the Multi-Pack with Beige selected gave 'product selection unavailable'. Before the theme reads the picker, the matching radio in the other option is ticked silently. Undo: delete this block. */
(function () {
  if (!/\/products\/ursa-tape\/?$/.test(location.pathname)) return;
  var lastColour = 'Beige';
  function radios() { return [].slice.call(document.querySelectorAll('variant-picker input[type=radio]')); }
  function find(group, test) {
    return radios().filter(function (r) { return r.name.indexOf(group) === 0 && test(r.value); })[0] || null;
  }
  var isMulti = function (v) { return /^12 Small/i.test(v); };
  var is30 = function (v) { return /^30 Small/i.test(v); };
  document.addEventListener('click', function (e) {
    var r = e.target;
    if (!r || r.tagName !== 'INPUT' || r.type !== 'radio' || !r.closest || !r.closest('variant-picker')) return;
    if (r.name.indexOf('Pack Size') === 0) {
      var col = find('Colour', isMulti(r.value) ? function (v) { return v === 'Multipack'; } : function (v) { return v === lastColour; });
      if (col) col.checked = true;
    } else if (r.name.indexOf('Colour') === 0) {
      if (r.value !== 'Multipack') lastColour = r.value;
      var pk = find('Pack Size', r.value === 'Multipack' ? isMulti : is30);
      if (pk) pk.checked = true;
    }
  }, true);
})();

/* 19 Oct 2026 (Sam): the header basket number didn't appear after adding a kit or bundle (it did for a normal Add to basket).
   The header's cart icon only listens for the theme's 'cart:update' event, which the normal product form fires and the kit /
   Bundle & Save / Tips "Add all" / Test It Kit buttons don't. Supercart fires 'supercart:open' on <html> after every successful
   add, and the kit builder and Bundle & Save also fire 'cart:refresh' / 'cart:updated'; on any of those, read the basket and
   fire the theme's 'cart:update' with the real count. (Supercart's own open/close events go to document, not <html>, so this
   only runs after real adds.) */
(function () {
  var t;
  function syncCount() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: c, sourceId: 'ursa-basket-count', data: { itemCount: c.item_count, source: 'ursa-basket-count' } } }));
      }).catch(function () {});
    }, 150);
  }
  // The kit builder, Bundle & Save / Pairs well with and Tips "Add all" fire cart:refresh / cart:updated once their kit code
  // is applied (2-5 s after the add). Redraw the Supercart drawer then too, or an open drawer keeps the pre-discount total.
  function afterKitCode() { syncCount(); if (typeof window.updateSupercart === 'function') window.updateSupercart(); }
  document.documentElement.addEventListener('supercart:open', syncCount);
  document.addEventListener('cart:refresh', afterKitCode);
  document.addEventListener('cart:updated', afterKitCode);
})();
